import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoArrowBg, LazySvgoArrowBlack, LazySvgoArrowRed, LazySvgoArrowSmallBlack, LazySvgoArrowWhite, LazySvgoAttached, LazySvgoAvailable, LazySvgoCheckBigRed, LazySvgoCheckWhite, LazySvgoCheck, LazySvgoClock, LazySvgoCloseBlack, LazySvgoCloseWhite, LazySvgoCommercial, LazySvgoCredit, LazySvgoDirectionBlack, LazySvgoDirectionSmallBlack, LazySvgoDirectionSmallWhite, LazySvgoDirectionWhite, LazySvgoDisable, LazySvgoDocLoadBlack, LazySvgoDocLoad, LazySvgoDownloadBlack, LazySvgoDownload, LazySvgoEmailBlack, LazySvgoEmailRed, LazySvgoEmail, LazySvgoExternalBlack, LazySvgoExternalWhite, LazySvgoFacebookBlack, LazySvgoFacebook, LazySvgoFileBlack, LazySvgoFileWhite, LazySvgoFilter, LazySvgoIconFacebook, LazySvgoIconInstagram, LazySvgoIconLinkedin, LazySvgoIconMessenger, LazySvgoIconTelegram, LazySvgoIconTiktok, LazySvgoIconViber, LazySvgoIconYoutube, LazySvgoIcons, LazySvgoInfoFilled, LazySvgoInfo, LazySvgoLinkBlack, LazySvgoLink, LazySvgoLocationRed, LazySvgoMailRed, LazySvgoMoto, LazySvgoOption, LazySvgoPassenger, LazySvgoPhoneBlack, LazySvgoPhoneRed, LazySvgoPlay, LazySvgoSearchBlack, LazySvgoSearсh, LazySvgoSpecsColorWhite, LazySvgoSpecsColor, LazySvgoSpecsDealerWhite, LazySvgoSpecsDealer, LazySvgoSpecsEngineWhite, LazySvgoSpecsEngine, LazySvgoSpecsFuelWhite, LazySvgoSpecsFuel, LazySvgoSpecsTransmissionWhite, LazySvgoSpecsTransmission, LazySvgoSpecsYearWhite, LazySvgoSpecsYear, LazySvgoStandard, LazySvgoState, LazySvgoTelegramBlack, LazySvgoTelegram, LazySvgoTruck, LazySvgoWarranty, LazyCheckbox, LazyFloatLabel, LazyInputGroup, LazyInputGroupAddon, LazyInputMask, LazyInputNumber, LazyInputText, LazyRadioButton, LazySelect, LazySlider, LazyTextarea, LazyButton, LazyScrollPanel, LazyTabs, LazyTabList, LazyTab, LazyTabPanels, LazyTabPanel, LazyDialog, LazyMessage, LazyTag } from '#components'
const lazyGlobalComponents = [
  ["SvgoArrowBg", LazySvgoArrowBg],
["SvgoArrowBlack", LazySvgoArrowBlack],
["SvgoArrowRed", LazySvgoArrowRed],
["SvgoArrowSmallBlack", LazySvgoArrowSmallBlack],
["SvgoArrowWhite", LazySvgoArrowWhite],
["SvgoAttached", LazySvgoAttached],
["SvgoAvailable", LazySvgoAvailable],
["SvgoCheckBigRed", LazySvgoCheckBigRed],
["SvgoCheckWhite", LazySvgoCheckWhite],
["SvgoCheck", LazySvgoCheck],
["SvgoClock", LazySvgoClock],
["SvgoCloseBlack", LazySvgoCloseBlack],
["SvgoCloseWhite", LazySvgoCloseWhite],
["SvgoCommercial", LazySvgoCommercial],
["SvgoCredit", LazySvgoCredit],
["SvgoDirectionBlack", LazySvgoDirectionBlack],
["SvgoDirectionSmallBlack", LazySvgoDirectionSmallBlack],
["SvgoDirectionSmallWhite", LazySvgoDirectionSmallWhite],
["SvgoDirectionWhite", LazySvgoDirectionWhite],
["SvgoDisable", LazySvgoDisable],
["SvgoDocLoadBlack", LazySvgoDocLoadBlack],
["SvgoDocLoad", LazySvgoDocLoad],
["SvgoDownloadBlack", LazySvgoDownloadBlack],
["SvgoDownload", LazySvgoDownload],
["SvgoEmailBlack", LazySvgoEmailBlack],
["SvgoEmailRed", LazySvgoEmailRed],
["SvgoEmail", LazySvgoEmail],
["SvgoExternalBlack", LazySvgoExternalBlack],
["SvgoExternalWhite", LazySvgoExternalWhite],
["SvgoFacebookBlack", LazySvgoFacebookBlack],
["SvgoFacebook", LazySvgoFacebook],
["SvgoFileBlack", LazySvgoFileBlack],
["SvgoFileWhite", LazySvgoFileWhite],
["SvgoFilter", LazySvgoFilter],
["SvgoIconFacebook", LazySvgoIconFacebook],
["SvgoIconInstagram", LazySvgoIconInstagram],
["SvgoIconLinkedin", LazySvgoIconLinkedin],
["SvgoIconMessenger", LazySvgoIconMessenger],
["SvgoIconTelegram", LazySvgoIconTelegram],
["SvgoIconTiktok", LazySvgoIconTiktok],
["SvgoIconViber", LazySvgoIconViber],
["SvgoIconYoutube", LazySvgoIconYoutube],
["SvgoIcons", LazySvgoIcons],
["SvgoInfoFilled", LazySvgoInfoFilled],
["SvgoInfo", LazySvgoInfo],
["SvgoLinkBlack", LazySvgoLinkBlack],
["SvgoLink", LazySvgoLink],
["SvgoLocationRed", LazySvgoLocationRed],
["SvgoMailRed", LazySvgoMailRed],
["SvgoMoto", LazySvgoMoto],
["SvgoOption", LazySvgoOption],
["SvgoPassenger", LazySvgoPassenger],
["SvgoPhoneBlack", LazySvgoPhoneBlack],
["SvgoPhoneRed", LazySvgoPhoneRed],
["SvgoPlay", LazySvgoPlay],
["SvgoSearchBlack", LazySvgoSearchBlack],
["SvgoSearсh", LazySvgoSearсh],
["SvgoSpecsColorWhite", LazySvgoSpecsColorWhite],
["SvgoSpecsColor", LazySvgoSpecsColor],
["SvgoSpecsDealerWhite", LazySvgoSpecsDealerWhite],
["SvgoSpecsDealer", LazySvgoSpecsDealer],
["SvgoSpecsEngineWhite", LazySvgoSpecsEngineWhite],
["SvgoSpecsEngine", LazySvgoSpecsEngine],
["SvgoSpecsFuelWhite", LazySvgoSpecsFuelWhite],
["SvgoSpecsFuel", LazySvgoSpecsFuel],
["SvgoSpecsTransmissionWhite", LazySvgoSpecsTransmissionWhite],
["SvgoSpecsTransmission", LazySvgoSpecsTransmission],
["SvgoSpecsYearWhite", LazySvgoSpecsYearWhite],
["SvgoSpecsYear", LazySvgoSpecsYear],
["SvgoStandard", LazySvgoStandard],
["SvgoState", LazySvgoState],
["SvgoTelegramBlack", LazySvgoTelegramBlack],
["SvgoTelegram", LazySvgoTelegram],
["SvgoTruck", LazySvgoTruck],
["SvgoWarranty", LazySvgoWarranty],
["Checkbox", LazyCheckbox],
["FloatLabel", LazyFloatLabel],
["InputGroup", LazyInputGroup],
["InputGroupAddon", LazyInputGroupAddon],
["InputMask", LazyInputMask],
["InputNumber", LazyInputNumber],
["InputText", LazyInputText],
["RadioButton", LazyRadioButton],
["Select", LazySelect],
["Slider", LazySlider],
["Textarea", LazyTextarea],
["Button", LazyButton],
["ScrollPanel", LazyScrollPanel],
["Tabs", LazyTabs],
["TabList", LazyTabList],
["Tab", LazyTab],
["TabPanels", LazyTabPanels],
["TabPanel", LazyTabPanel],
["Dialog", LazyDialog],
["Message", LazyMessage],
["Tag", LazyTag],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
